module.exports = __webpack_public_path__ + "img/fluffyProject.f2fb3717.jpeg";